import { api } from "@api/api";
import {
  AgreementErpPlan,
  GetAgreementErpPlansResult,
  GetPlansErpResponse,
} from "./types";

/**
 * Normaliza um item da API get_plans_erp para AgreementErpPlan.
 */
function normalizePlan(
  p: GetPlansErpResponse["data"][number],
  typeMapping: string
): AgreementErpPlan {
  const valueStr =
    typeof p.value === "number" ? String(p.value).replace(".", ",") : String(p.value);
  return {
    id: p.slug,
    name: p.name,
    slug: p.slug,
    name_plan: p.name,
    price: typeof p.value === "number" ? p.value : undefined,
    value: valueStr,
    status: p.status,
    active: p.active,
    count_clients: p.count_clients,
    count_clients_active: p.count_clients_active,
    type_mapping: typeMapping,
  };
}

/**
 * Busca os planos ERP do convênio via API v1/get_plans_erp (GET).
 * Mesmo padrão do front-end: header X-Agreement-Id e planos em `data`.
 */
export async function getAgreementErpPlansService(
  agreementId: string
): Promise<GetAgreementErpPlansResult> {
  const { data } = await api.get<GetPlansErpResponse>("v1/get_plans_erp", {
    headers: {
      "X-Agreement-Id": String(agreementId),
    },
  });

  const typeMapping = data?.map_type?.description ?? data?.map_type?.slug ?? "";
  const plans: AgreementErpPlan[] = (data?.data ?? []).map((p) =>
    normalizePlan(p, typeMapping)
  );

  return {
    data: plans,
    report: data?.report ?? null,
    map_type: data?.map_type ?? null,
  };
}
